var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"alert"},[_vm._t("default"),_vm._v(" "),_c('i',{staticClass:"alert__closebtn el-icon-close",on:{"click":function($event){_vm.visible=!_vm.visible}}})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }